import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import "./BlacklistedMembers.css";
import { apiGet } from "../../../Services";

const BlacklistedMembers = () => {
  const [blacklistedMembers, setBlacklistedMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch blacklisted members from the API
    // const fetchBlacklistedMembers = async () => {
      // try {
      //   const response = await fetch("/api/blacklisted-members");
      //   const data = await response.json();
      //   setBlacklistedMembers(data);
      //   setBlacklistedMembers([]); // for now empty array
      //   setLoading(false);
      // } catch (error) {
      //   console.error("Error fetching blacklisted members:", error);
      //   setLoading(false);
      // }
      setLoading(true);
      apiGet("/api/blacklist")
        .then((res) => {
          setBlacklistedMembers(res.data);
          console.log(res.data);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    // };

    // fetchBlacklistedMembers();
  }, []);

  return (
    <>
      <Helmet>
        <title>Blacklisted Members | Manav Adhikar Forum</title>
        <meta
          name="description"
          content="List of blacklisted members of Manav Adhikar Forum."
        />
        <meta
          name="keywords"
          content="Manav Adhikar Forum, human rights, India, blacklisted members, blacklist"
        />
        <link
          rel="canonical"
          href="https://manavadhikarforum.in/Blacklisted-Members"
        />
      </Helmet>

      <Container
        className="blacklisted-members-page py-5"
        style={{ padding: "0 12px" }}
      >
        <Row className="mb-5">
          <Col>
            <div className="d-flex flex-column mb-4 text-center align-items-center">
              <h1
                className="text-center page-title"
                style={{ color: "#1a5276", fontWeight: "bold" }}
              >
                Blacklisted Members
                <div
                  className="rounded-pill mt-2 bg-warning"
                  style={{
                    height: "5px",
                    width: "15%",
                  }}
                ></div>
              </h1>
            </div>
            {loading ? (
              <p className="text-center">Loading...</p>
            ) : blacklistedMembers.length > 0 ? (
              <Row>
                {blacklistedMembers.map((member, index) => (
                  <Col key={index} md={6} lg={4} className="mb-4">
                    <Card className="h-100 blacklisted-member-card">
                      <div className="blacklisted-member-image-container">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="blacklisted-member-profile-img"
                        />
                      </div>
                      <Card.Body className="text-center">
                        <h5 className="blacklisted-member-name">
                          {member.name}
                        </h5>
                        <p className="blacklisted-member-place">
                          {member.place}
                        </p>
                        <p className="blacklisted-member-reason">
                          <strong>Reason:</strong> {member.reason}
                        </p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <p className="text-center">No blacklisted members found.</p>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BlacklistedMembers;
